export const isPrivateRelay = (email) => { 
    if([null,undefined,''].includes(email)) return false;
    return email?.split('@')[1]?.toLowerCase() === 'privaterelay.appleid.com';
}